//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import { mapState } from 'vuex'
    export default {
        fetchOnServer: false,
        async fetch() {
            await Promise.all([ 
                this.$store.dispatch('pagesStore/getPage', 'webcamsex'),
                this.$store.dispatch('bannerStore/getBanner', 'webcamCollection'),
                this.$store.dispatch('camStore/getCams', this.camsQuery)
            ])
        },
        head() {
            return {
                title: this.pages.webcamsex && this.pages.webcamsex.seo ? this.pages.webcamsex.seo.title : 'Webcamsex | Hollandse webcam meiden | Meiden van Holland',
                meta: [
                    { hid: 'title', name: 'title', content: this.pages.webcamsex && this.pages.webcamsex.seo ? this.pages.webcamsex.seo.title : 'Webcamsex | Hollandse webcam meiden | Meiden van Holland' },
                    { hid: 'og:title', name: 'og:title', content: this.pages.webcamsex && this.pages.webcamsex.seo ? this.pages.webcamsex.seo.title : 'Webcamsex | Hollandse webcam meiden | Meiden van Holland' },
                    { hid: 'description', name: 'description', content: this.pages.webcamsex && this.pages.webcamsex.seo ? this.pages.webcamsex.seo.description : 'Geile webcamsex met de geilste Hollandse meiden achter de cam. Live met echte Meiden van Holland en Amateurs.'},
                    { hid: 'og:description', name: 'og:description', content: this.pages.webcamsex && this.pages.webcamsex.seo ? this.pages.webcamsex.seo.description : 'Geile webcamsex met de geilste Hollandse meiden achter de cam. Live met echte Meiden van Holland en Amateurs.' },
                    { hid: 'og:url', name: 'og:url', content: process.env.FE_URL + '/webcamsex' },
                    { hid: 'keywords', name: 'keywords', content: this.pages.webcamsex && this.pages.webcamsex.seo ? this.pages.webcamsex.seo.keywords : 'webcamsex, webcam sex, geile webcam, cambabes'},
                ]
            }
        },
        components: {
            dummyItem: () => import('~/components/content/dummy/cam_dummy.vue'),
            camItem: () => import('~/components/content/cam/cam.vue'),
            filters: () => import('~/components/content/cam/filters_cam'),
            mobileFilters: () => import('~/components/content/cam/filters/mobileFilters'),
            activefilters: () => import('~/components/content/cam/filters/active_filters_cam'),
            // registerButton: () => import('~/components/content/cam/registerButton.vue'),
            banner: () => import('~/components/banner.vue'),
            about: () => import('~/components/about_section.vue')
        },
        computed: {
            ...mapState({
                cams: ({ camStore: {cams} }) => cams,
                camsQuery: ({ camStore: {camsQuery} }) => camsQuery,
                camFilter: ({ camStore: {camFilter} }) => camFilter,
                loading: ({ camStore: {loading} }) => loading,
                banner: ({ bannerStore: {banner} }) => banner,
                pages: ({ pagesStore: {pages} }) => pages,
            }),
        },
        methods: {
          loadMore() {
            let loadmoreQuery = JSON.parse(JSON.stringify(this.camsQuery));
            loadmoreQuery.page = this.camsQuery.page + 1 ;
            this.$store.commit('camStore/updateQuery', loadmoreQuery);
            this.$store.dispatch('camStore/getCams', loadmoreQuery);
        }
    },
}
